import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-system-connection-key-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule
  ],
  templateUrl: './system-connection-key.dialog.html',
  styleUrls: ['./system-connection-key.dialog.scss']
})
export class SystemConnectionKeyDialog {
  secretKey: string = '';
  error: string = '';

  constructor(
    private dialogRef: MatDialogRef<SystemConnectionKeyDialog>
  ) {}

  onSubmit(): void {
    if (!this.secretKey) {
      this.error = 'Please enter a secret key';
      return;
    }
    this.dialogRef.close(this.secretKey);
  }
} 